exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.yt-link img[data-v-01c9d6ce]{position:absolute;max-width:100%;max-height:100%;margin:auto;top:0;bottom:0;left:0;right:0}a.yt-link .play-wrapper[data-v-01c9d6ce]{position:absolute;top:calc(50% - 30px);left:0;right:0}a.yt-link .play-wrapper .play[data-v-01c9d6ce]{width:100%;font-size:60px;text-align:center;color:#fff;opacity:.5}.viewer[data-v-01c9d6ce]{background-color:rgba(0,0,0,.9);z-index:-1}.viewer.show[data-v-01c9d6ce]{z-index:2000}.viewer iframe[data-v-01c9d6ce]{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;transition:width,height .35s ease;width:304px;height:154px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01c9d6ce","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/YouTube.vue
// module id = 292
// module chunks = 7 8 9